import { FC } from 'react';
import { Box, Skeleton } from '@mui/material';
import { LIST_ROW_DIMENSIONS } from '@/constants/layout';

interface SkeletonListRowProps {
  showThumbnails?: boolean;
}

const SkeletonListRow: FC<SkeletonListRowProps> = ({ showThumbnails = false }) => {
  const height = showThumbnails
    ? LIST_ROW_DIMENSIONS.EXPANDED_WITH_THUMBNAIL_HEIGHT
    : LIST_ROW_DIMENSIONS.EXPANDED_HEIGHT;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        px: 2,
        py: 1,
        minHeight: height,
        borderBottom: '1px solid',
        borderColor: 'divider',
        gap: 1.5,
      }}
    >
      {showThumbnails && (
        <Skeleton
          variant="rounded"
          width={LIST_ROW_DIMENSIONS.THUMBNAIL_SIZE}
          height={LIST_ROW_DIMENSIONS.THUMBNAIL_SIZE}
          sx={{ borderRadius: `${LIST_ROW_DIMENSIONS.THUMBNAIL_BORDER_RADIUS}px`, flexShrink: 0 }}
        />
      )}
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 0.5, minWidth: 0 }}>
        <Skeleton variant="text" width="60%" height={22} />
        <Skeleton variant="text" width="40%" height={16} />
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <Skeleton variant="rounded" width={60} height={18} />
          <Skeleton variant="rounded" width={50} height={18} />
        </Box>
      </Box>
      <Skeleton variant="text" width={120} height={18} sx={{ flexShrink: 0 }} />
    </Box>
  );
};

export default SkeletonListRow;
